webpackJsonp([6],{

/***/ 1818:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(110);
__webpack_require__(201);
var classNames = __webpack_require__(2);
var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(25);
var AllPermissions_1 = __webpack_require__(73);
var utilities_1 = __webpack_require__(13);
var Notifications = __webpack_require__(1819);
var NotificationMessageNotifier = Notifications.NotificationMessageNotifier;
var App = (function (_super) {
    __extends(App, _super);
    function App(props) {
        var _this = _super.call(this, props) || this;
        _this.base = "";
        _this.currentAgentGroupEnvironment = {};
        _this.generateHref = function (link) {
            if (!link.overwriteCurrentEnvironmentInUrl) {
                return _this.base + link.href;
            }
            var environment = _this.getEnvironmentFromUrl();
            return _this.base + link.href + environment.environmentName + (link.useAgentGroups ? environment.agentGroupName : "");
        };
        _this.state = {
            activeLink: "",
            hasRightsFor: {}
        };
        _this.tick = _this.tick.bind(_this);
        setInterval(_this.tick, 500);
        return _this;
    }
    App.prototype.componentDidMount = function () {
        try {
            this.setState({ hasRightsFor: utilities_1.Utilities.getAllUserPermissions() });
        }
        catch (exception) {
            console.error("Unable to retrive user permissions: " + exception);
            throw exception;
        }
        this.updateState();
    };
    App.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement("ul", { className: "nav navbar-nav" }, navigationBarData.map(function (link) {
                return _this.state.hasRightsFor[link.permission] ?
                    link.children != null ?
                        React.createElement("li", { key: link.activeLinkName, className: classNames("dropdown", { active: (link.children.some(function (x) { return x.activeLinkName === _this.state.activeLink; })) }) },
                            React.createElement("a", { href: "#", className: "dropdown-toggle", "data-toggle": "dropdown", role: "button", "aria-haspopup": "true", "aria-expanded": "false" },
                                link.label,
                                " ",
                                React.createElement("span", { className: "caret" })),
                            React.createElement("ul", { className: "dropdown-menu" }, link.children.map(function (childLink) {
                                return _this.state.hasRightsFor[childLink.permission] ?
                                    React.createElement("li", { key: childLink.activeLinkName, className: classNames("dropdown-menu-item menu-item-reversed-padding", { selected: (_this.state.activeLink === childLink.activeLinkName) }) },
                                        React.createElement("a", { href: _this.generateHref(childLink) }, childLink.label))
                                    : null;
                            })))
                        : React.createElement("li", { key: link.activeLinkName, className: classNames({ active: (_this.state.activeLink === link.activeLinkName) }) },
                            React.createElement("a", { href: _this.generateHref(link) }, link.label))
                    : null;
            })),
            React.createElement(NotificationMessageNotifier, null)));
    };
    App.prototype.tick = function () {
        var env = this.getEnvironmentFromUrl();
        if (!_.isEqual(env, this.currentAgentGroupEnvironment)) {
            this.updateState();
        }
    };
    App.prototype.updateState = function () {
        this.base = document.getElementsByTagName("base")[0].href;
        this.currentAgentGroupEnvironment = this.getEnvironmentFromUrl();
        var urlParts = this.getUriPartsWithoutBase();
        var controller = urlParts[0];
        this.setState({ activeLink: controller });
    };
    App.prototype.getUriPartsWithoutBase = function () {
        var urlPart = window.location.href;
        var basePart = this.base;
        var urlPartWithoutBase = urlPart.replace(basePart, "").split("/");
        return urlPartWithoutBase;
    };
    App.prototype.getEnvironmentFromUrl = function () {
        var urlParts = this.getUriPartsWithoutBase();
        var environmentPart = "";
        var agentGroupPart = "";
        switch (this.state.activeLink) {
            case "Process":
            case "SubProcess":
                if ((urlParts[1] === "List") && urlParts.length >= 3) {
                    environmentPart = "/" + urlParts[2];
                    agentGroupPart = urlParts.length >= 4 ? "/" + urlParts[3] : "";
                }
                break;
            case "EnvironmentVariables":
            case "MonitoringRules":
                if (urlParts.length >= 3) {
                    environmentPart = "/" + urlParts[2];
                }
                break;
            case "Environment":
            case "ApiManagement":
                if (urlParts.length >= 2) {
                    environmentPart = "/" + urlParts[1];
                    agentGroupPart = urlParts.length >= 3 ? "/" + urlParts[2] : "";
                }
                break;
            default:
                environmentPart = "";
        }
        return { agentGroupName: agentGroupPart, environmentName: environmentPart };
    };
    return App;
}(React.Component));
var navigationBarData = [
    { href: "ApiManagement", activeLinkName: "ApiManagement", label: FRENDS.Localizations.ApiManagement, permission: AllPermissions_1.Permissions.ApiManagementView, overwriteCurrentEnvironmentInUrl: true, useAgentGroups: true },
    { href: "Process/List", activeLinkName: "Process", label: FRENDS.Localizations.Processes, permission: AllPermissions_1.Permissions.ProcessView, overwriteCurrentEnvironmentInUrl: true, useAgentGroups: true },
    { href: "SubProcess/List", activeLinkName: "SubProcess", label: FRENDS.Localizations.Subprocesses, permission: AllPermissions_1.Permissions.SubProcessEdit, overwriteCurrentEnvironmentInUrl: true, useAgentGroups: true },
    { href: "EnvironmentVariables/List", activeLinkName: "EnvironmentVariables", label: FRENDS.Localizations.EnvironmentVariables, permission: AllPermissions_1.Permissions.EnvironmentVariablesEdit, overwriteCurrentEnvironmentInUrl: true },
    {
        href: "", activeLinkName: "Administration", label: FRENDS.Localizations.Administration, permission: AllPermissions_1.Permissions.AdministrationView, overwriteCurrentEnvironmentInUrl: false,
        children: [
            { href: "Environment", activeLinkName: "Environment", label: FRENDS.Localizations.Environments, permission: AllPermissions_1.Permissions.EnvironmentEdit, overwriteCurrentEnvironmentInUrl: true, useAgentGroups: true },
            { href: "Task", activeLinkName: "Task", label: FRENDS.Localizations.Tasks, permission: AllPermissions_1.Permissions.TaskView, overwriteCurrentEnvironmentInUrl: false },
            { href: "MonitoringRules/List", activeLinkName: "MonitoringRules", label: FRENDS.Localizations.MonitoringRules, permission: AllPermissions_1.Permissions.MonitoringRulesView, overwriteCurrentEnvironmentInUrl: true },
            { href: "UserManagement", activeLinkName: "UserManagement", label: FRENDS.Localizations.UserManagement_Users, permission: AllPermissions_1.Permissions.UserManagementAdmin, overwriteCurrentEnvironmentInUrl: false },
            { href: "ApiKeyManagement", activeLinkName: "ApiKeyManagement", label: FRENDS.Localizations.Administration_ApiKeys, permission: AllPermissions_1.Permissions.ApiKeyManagementAdmin, overwriteCurrentEnvironmentInUrl: false }
        ]
    }
];
var navigationContainer = document.getElementById("menu");
if (navigationContainer) {
    var render = function (Component) { return ReactDOM.render((React.createElement(Component, null)), navigationContainer); };
    render(App);
}


/***/ }),

/***/ 1819:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = __webpack_require__(0);
var ReactBootstrap = __webpack_require__(9);
var Fade = ReactBootstrap.Fade;
var NotificationMessageNotifier = (function (_super) {
    __extends(NotificationMessageNotifier, _super);
    function NotificationMessageNotifier(props) {
        var _this = _super.call(this, props) || this;
        _this.messageKey = "notification/lastMessages";
        _this.handleDismiss = function (id) {
            var messages = _this.state.messages;
            var message = _.find(messages, function (msg) { return msg.id == id; });
            message.viewed = true;
            _this.updateLocalStorage(messages);
            _this.setState({
                messages: messages
            });
        };
        _this.toggleMessage = function () {
            var toggledViewStatus = !(_.find(_this.state.messages, function (msg) { return msg.viewed; }) || { viewed: false }).viewed;
            var messages = _.map(_this.state.messages, function (msg) { msg.viewed = toggledViewStatus; return msg; });
            _this.updateLocalStorage(messages);
            _this.setState({
                messages: messages
            });
        };
        _this.state = {
            messages: []
        };
        return _this;
    }
    NotificationMessageNotifier.prototype.updateViewedStatusFromLocalStorage = function (messages) {
        if (typeof (Storage) !== "undefined") {
            var localStoreMessages = (JSON.parse(localStorage.getItem(this.messageKey)) || []);
            messages = _.map(messages, function (msg) {
                var localMessage = localStoreMessages.find(function (lmsg) { return lmsg.id == msg.id; });
                if (localMessage != null) {
                    msg.viewed = localMessage.viewed;
                }
                return msg;
            });
            return messages;
        }
    };
    NotificationMessageNotifier.prototype.updateLocalStorage = function (messages) {
        if (typeof (Storage) !== "undefined") {
            var messageStatuses = _.map(messages, function (msg) { return ({ id: msg.id, viewed: msg.viewed }); });
            localStorage.setItem(this.messageKey, JSON.stringify(messageStatuses));
        }
    };
    NotificationMessageNotifier.prototype.componentDidMount = function () {
        var _this = this;
        fetch("api/navigation/notification", { credentials: 'same-origin' }).then(function (response) {
            if (response.ok) {
                response.json().then(function (result) {
                    var messages = _this.updateViewedStatusFromLocalStorage(result);
                    _this.setState({
                        messages: messages
                    });
                }).catch(function (err) { return Promise.reject(err); });
            }
            else {
                response.json().then(function (err) { return Promise.reject(err); });
            }
        }).catch(function (err) { return console.error("Unable to retrive notification message: " + err); });
    };
    NotificationMessageNotifier.prototype.render = function () {
        var _this = this;
        if (this.state.messages == null || this.state.messages.length === 0)
            return null;
        return (React.createElement("div", null,
            React.createElement("ul", { className: "nav navbar-nav navbar-right" },
                React.createElement("li", null,
                    React.createElement("p", { className: "navbar-text pointer " },
                        React.createElement("span", { className: "glyphicon glyphicon-warning-sign state-color-started", onClick: this.toggleMessage })))),
            React.createElement("div", { className: "clear notification-alert-container" }, _.map(this.state.messages, function (message) {
                return React.createElement(NotificationMessageViewer, { key: message.id, message: message.message, viewed: message.viewed, onDismiss: function () { return _this.handleDismiss(message.id); } });
            }))));
    };
    return NotificationMessageNotifier;
}(React.Component));
exports.NotificationMessageNotifier = NotificationMessageNotifier;
var NotificationMessageViewer = (function (_super) {
    __extends(NotificationMessageViewer, _super);
    function NotificationMessageViewer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NotificationMessageViewer.prototype.render = function () {
        return (React.createElement(Fade, { in: !this.props.viewed, unmountOnExit: true },
            React.createElement("div", { className: "clear" },
                React.createElement("div", { className: "alert alert-warning notification-alert" },
                    React.createElement("span", { className: "close", onClick: this.props.onDismiss }, "\u00D7"),
                    React.createElement("p", null, this.props.message)))));
    };
    ;
    return NotificationMessageViewer;
}(React.Component));
exports.NotificationMessageViewer = NotificationMessageViewer;


/***/ }),

/***/ 73:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Permissions;
(function (Permissions) {
    Permissions["AdministrationView"] = "Frends.Administration.View";
    Permissions["ApiKeyManagementAdmin"] = "Frends.ApiKeyManagement.Admin";
    Permissions["ApiManagementView"] = "Frends.ApiManagement.View";
    Permissions["ApiManagementEdit"] = "Frends.ApiManagement.Edit";
    Permissions["ApiManagementDeploy"] = "Frends.ApiManagement.Deploy";
    Permissions["EnvironmentEdit"] = "Frends.Environment.Edit";
    Permissions["EnvironmentVariablesEdit"] = "Frends.EnvironmentVariables.Edit";
    Permissions["MonitoringRulesView"] = "Frends.MonitoringRules.View";
    Permissions["ProcessEdit"] = "Frends.Process.Edit";
    Permissions["ProcessStart"] = "Frends.Process.Start";
    Permissions["ProcessDeploy"] = "Frends.Process.Deploy";
    Permissions["ProcessView"] = "Frends.Process.View";
    Permissions["ProcessInstanceEdit"] = "Frends.ProcessInstance.Edit";
    Permissions["SubProcessEdit"] = "Frends.Process.Edit";
    Permissions["TaskView"] = "Frends.Task.View";
    Permissions["UserManagementAdmin"] = "Frends.UserManagement.Admin";
})(Permissions = exports.Permissions || (exports.Permissions = {}));
exports.AllPermissionsTrue = (_a = {},
    _a[Permissions.ApiManagementView] = true,
    _a[Permissions.ApiManagementEdit] = true,
    _a[Permissions.ApiManagementDeploy] = true,
    _a[Permissions.ProcessView] = true,
    _a[Permissions.ProcessEdit] = true,
    _a[Permissions.ProcessStart] = true,
    _a[Permissions.ProcessDeploy] = true,
    _a[Permissions.EnvironmentVariablesEdit] = true,
    _a[Permissions.AdministrationView] = true,
    _a[Permissions.EnvironmentEdit] = true,
    _a[Permissions.TaskView] = true,
    _a[Permissions.MonitoringRulesView] = true,
    _a[Permissions.UserManagementAdmin] = true,
    _a[Permissions.ApiKeyManagementAdmin] = true,
    _a[Permissions.ProcessInstanceEdit] = true,
    _a);
var _a;


/***/ })

},[1818]);


// WEBPACK FOOTER //
// navigation.bundle.js